import script from "./TelegramWhitepaper.vue?vue&type=script&setup=true&lang=js"
export * from "./TelegramWhitepaper.vue?vue&type=script&setup=true&lang=js"

import "./TelegramWhitepaper.vue?vue&type=style&index=0&id=364fdf88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-364fdf88"]])

export default __exports__